import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class CustomUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        if (url && !url.includes('/login?impersonate=') && !url.includes('account/resetpassword'))
            return super.parse(url.toLowerCase());
        else
            return super.parse(url);
    }
}